import EventsCard from './EventCard';

export { EventsCard };
export default EventsCard;
